import gql from 'graphql-tag'

const GET_USER = () => {
  return gql`
    {
      user {
        id
        firstName
        lastName
        email
        ssoUserId
        expiration
        preferredName
        hideName
        role {
          id
          name
        }
        canCreate
        canEdit
        canDelete
        isQAUser
      }
    }
  `
}

export default GET_USER
